/* eslint-disable  @typescript-eslint/no-explicit-any */
import axios from "axios";

export const spGet = (url: string): any => {
  return new Promise(function (fulfill, reject) {
    axios({
      method: "get",
      url: url,
      headers: { Accept: "application/json;odata=verbose" },
    }).then(
      (response) => {
        const items =
          response.data && response.data.d && response.data.d.results
            ? response.data.d.results
            : response.data.d
            ? response.data.d
            : [];
        fulfill(items);
      },
      (error) => {
        console.log("Error in spGet: ", error);
        reject(error.response);
      }
    );
  });
};

export const spPost = (url: string, request: any): Promise<any> => {
  return axios
    .post(
      url,
      request,
      {
        headers: {
          Accept: "application/json;odata=nometadata",
          "X-RequestDigest": getRequestDigestValue(),
        },
      }
    )
    .then(response => {
      return response.data;
    })
    .catch((error: any) => {
      if (error.response?.data) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject(error);
    });
};

export const spCreate = async (
  weburl: string,
  url: string,
  data: any,
  targetList: string
): Promise<any> => {
  // return new Promise<any[]>(function (fulfill, reject) {
  const spListItemType: string = "SP.Data." + targetList + "ListItem";
  const dataToPost = { ...data, __metadata: { type: spListItemType } };
  const requestDigest: string = await getFormDigest(weburl);
  axios
    .post(url, dataToPost, {
      headers: {
        Accept: "application/json;odata=verbose",
        "Content-Type": "application/json;odata=verbose",
        "X-RequestDigest": requestDigest,
      },
    })
    .then(
      (response) => {
        // console.log("SPI Response: ", response);
        return response.data.d;
      },
      (error) => {
        console.log("Error in spCreate: ", error);
        return "Error in spCreate. See console for more info.";
      }
    );
  // });
};

const getFormDigest = async (webUrl: string): Promise<string> => {
  try {
    const response = await axios.post(
      `${webUrl}/_api/contextinfo`,
      null, // No body needed
      {
        headers: {
          Accept: "application/json;odata=verbose",
        },
        withCredentials: true, // Optional: if you're relying on browser session
      }
    );

    const digestValue =
      response.data.d.GetContextWebInformation.FormDigestValue;
    console.log("ContextInfo:", digestValue);
    return digestValue;
  } catch (error: any) {
    console.error("Error in getFormDigest:", error.response);
    throw error;
  }
};

const getRequestDigestValue = () => {
  const digestElem = document.getElementById(
    "__REQUESTDIGEST"
  ) as HTMLInputElement | null;
  return digestElem ? digestElem.value : "";
};
